import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import Icon, { GLYPHS } from '../../../../../../../app/common/icon';
import styles from './styles.module.scss';
export var Expander = function (_a) {
    var isExpanded = _a.isExpanded;
    return (_jsx(Icon, { glyph: GLYPHS.chevronDropdown, size: "micro", className: classnames(styles.expander, { 'u-rotate-180': isExpanded }) }));
};
